"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wrappers = void 0;
const helpers_1 = require("./helpers");
const ValidationErrors_1 = require("./ValidationErrors");
const validators_1 = require("./validators");
exports.Wrappers = {
    required(validator) {
        return (val) => {
            return validators_1.Validators.notEmpty(val) || validator(val);
        };
    },
    notRequired(validator) {
        return (val) => {
            return validators_1.Validators.notEmpty(val) === ValidationErrors_1.ValidationErrors.ShouldBeNonEmpty
                ? ValidationErrors_1.ValidationErrors.None
                : validator(val);
        };
    },
    thrower(validator) {
        return (val) => {
            (0, helpers_1.throwNotOk)(validator(val));
        };
    },
};
//# sourceMappingURL=wrappers.js.map